import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  get pageNavNext() {
    return this.element.querySelector('#page-nav .next a');
  }

  connect() {
    const agreeButton = document.querySelector(".game#agree");
    const agreeFeedback = document.querySelector(".game#agree-feedback");
    const disagreeButton = document.querySelector(".game#disagree");
    const disagreeFeedback = document.querySelector(".game#disagree-feedback");

    if (agreeButton && disagreeButton) {
      agreeButton.addEventListener("click", () => {
        disagreeFeedback.style.display = "none";
        agreeFeedback.style.display = "table-cell";
        if (agreeFeedback.classList.contains("correct")) {
          this.enableNextNavigation();
        }
      });
      disagreeButton.addEventListener("click", () => {
        agreeFeedback.style.display = "none";
        disagreeFeedback.style.display = "table-cell";
        if (disagreeFeedback.classList.contains("correct")) {
          this.enableNextNavigation();
        }
      });
    }
  }

  enableNextNavigation() {
    this.pageNavNext.removeAttribute('disabled');
  }
}
